import z from "zod";

export const BooleanValueSchema = z.boolean();
